import type { ListActivitiesQuery, ReportPeriod, SportGroup } from '@gd/shared'

/** Central query-key factory. Keep all TanStack Query keys here so invalidation stays consistent. */
export const keys = {
  me: () => ['me'] as const,
  athletes: () => ['athletes'] as const,
  athlete: (slug: string) => ['athletes', slug] as const,
  summary: (athleteId: string, date?: string) => ['summary', athleteId, date ?? 'latest'] as const,
  activities: (athleteId: string, query: ListActivitiesQuery) =>
    ['activities', athleteId, query] as const,
  activity: (id: string) => ['activity', id] as const,
  wellness: (athleteId: string, from: string, to: string) =>
    ['wellness', athleteId, from, to] as const,
  events: (athleteId: string, from: string, to: string) => ['events', athleteId, from, to] as const,
  weekly: (athleteId: string, from: string, to: string) => ['weekly', athleteId, from, to] as const,
  fitness: (athleteId: string, from: string, to: string) =>
    ['fitness', athleteId, from, to] as const,
  syncRuns: (athleteId?: string, limit?: number) =>
    ['sync-runs', athleteId ?? 'all', limit ?? 'default'] as const,
  activityDetail: (id: string, points?: number, splits?: 'mi' | 'km') =>
    ['activity-detail', id, points ?? 'default', splits ?? 'mi'] as const,
  status: (athleteId: string, date?: string) => ['status', athleteId, date ?? 'latest'] as const,
  records: (athleteId: string, sport: SportGroup, from?: string, to?: string) =>
    ['records', athleteId, sport, from ?? 'all', to ?? 'all'] as const,
  report: (athleteId: string, period: ReportPeriod, date?: string) =>
    ['report', athleteId, period, date ?? 'latest'] as const,
  brief: (athleteId: string, days?: number) => ['brief', athleteId, days ?? 'default'] as const,
}
